import Vue from 'vue'
import Router from 'vue-router'

const HomeView = () => import('@/views/HomeView')
const UploadVideo = () => import('@/views/UploadVideo')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_routeBase,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'HomeView',
      component: HomeView
    },
    {
      path: '/upload',
      name: 'UploadVideo',
      component: UploadVideo
    },
    {
      path: '*',
      name: 'ErrorRoute',
      component: HomeView
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            selector: to.hash
          })
        }, 500)
      })
    }
  }
})
